import React, { useMemo } from "react";
import useIdentity from "@/features/ui/hooks/use-identity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";
import useListAllCompanies, {
  ListAllCompaniesPathParameter,
  ListAllCompaniesRequest,
} from "@/features/line-sheet-sets/hooks/use-list-all-companies";
import { CompanyType } from "@/features/types";

const useGetCompanies = (types: CompanyType[]) => {
  const identity = useIdentity();
  const key = useMemo(():
    | {
        parameter: ListAllCompaniesPathParameter;
        request: ListAllCompaniesRequest;
      }
    | undefined => {
    if (identity?.company) {
      let request: ListAllCompaniesRequest = {};
      if (types) {
        request.type__in = types;
      }
      return {
        parameter: {
          by: identity.company.type,
          companyId: identity.company.id,
        },
        request,
      };
    }
    return undefined;
  }, [identity, types]);

  let { isLoading, data, mutate, error } = useListAllCompanies(
    key?.parameter,
    key?.request
  );

  return data;
};

export default useGetCompanies;
